module.exports = __webpack_public_path__ + "static/img/center.574944d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/center.png
// module id = Fvzf
// module chunks = 0